import React, { createContext, useContext, useState, ReactNode } from "react";

export interface KycData {
  email?: string;
  whatsapp_number?: string;
  country_name?: string;
  country?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  business_verifications?: string,
  password?: string;
  confirm_password?: string;
  business_address?: string;
  company_registration_certificate?: File[];        // Single file or array (we'll use array for consistency)
  directors_government_id?: File[];
  first_name?: string;
  last_name?: string;
  referral_code?: string
  business_name?: string;
  website_url?: string;
  business_type?: string;
  business_category?: string;
}

interface KycContextType {
  kycData: KycData;
  setKycData: React.Dispatch<React.SetStateAction<KycData>>;
}

const KycContext = createContext<KycContextType | undefined>(undefined);

export const KycProvider = ({ children }: { children: ReactNode }) => {
  const [kycData, setKycData] = useState<KycData>({});
  return (
    <KycContext.Provider value={{ kycData, setKycData }}>
      {children}
    </KycContext.Provider>
  );
};

export const useKyc = () => {
  const context = useContext(KycContext);
  if (!context) throw new Error("useSignUp must be used within SignupProvider");
  return context;
};
